module.exports = __webpack_public_path__ + "img/plugin-how-it-works-info_0.663d5c94.svg";